import { normalizeBoolean } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_DECISION_MAKERS_AUTOADD_ENABLED = createFcmConfig('decision_makers_autoadd_enabled', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
